// custom typefaces
import "@fontsource-variable/montserrat";
import "@fontsource/merriweather";
// normalize CSS across browsers
import "./src/normalize.css";
// custom CSS styles
import "./src/style.css";
import "./src/saas.css";

// Highlighting for code blocks
import "prismjs/themes/prism.css";

// Tailwind
import "./src/global.css";

import React from "react";
import CookieNotice from "./src/components/CookieNotice";
import { getConsent, loadTrackingScripts } from "./src/utils/tracking";

export const wrapPageElement = ({ element }) => (
  <>
    {element}
    <CookieNotice />
  </>
);

// ─── Opt-in script loader ─────────────────────────────────────────────────────
//
// Non-essential scripts (Smartlook, Google Ads) are BLOCKED by default.
// They only load when the user has explicitly accepted via the cookie notice
// or the /privacy-choices page.  GPC is always honoured as a decline.
//
// Consent state is managed in src/utils/tracking.ts (shared with the notice
// component so both surfaces read/write the same cookie + localStorage key).
//
export const onClientEntry = () => {
  if (getConsent() === "accepted") {
    loadTrackingScripts();
  }
  // "declined", GPC active, or not yet set → scripts stay blocked.
  // gtag_report_conversion remains the no-op stub defined in seo.tsx.
};

// export const onRouteUpdate = loc => {
//   const { state } = loc.location;

//   if (state && state.refocusId) {
//     const elem = document.getElementById(state.refocusId);

//     if (elem) {
//       elem.focus();
//     }
//   }
// };
